module.exports = __webpack_public_path__ + "static/media/Bison.svg";